import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useGiftStats = (userId?: string | null) => {
  return useQuery({
    queryKey: ["gift-stats", userId],
    enabled: !!userId,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    queryFn: async () => {
      if (!userId) throw new Error("Not authenticated");

      // Get sent gifts stats
      const { data: sentGifts, error: sentError } = await supabase
        .from("gifts")
        .select("amount, commission_amount")
        .eq("sender_id", userId)
        .eq("status", "succeeded");

      if (sentError) throw sentError;

      // Get received gifts stats
      const { data: receivedGifts, error: receivedError } = await supabase
        .from("gifts")
        .select("net_amount, amount")
        .eq("recipient_id", userId)
        .eq("status", "succeeded");

      if (receivedError) throw receivedError;
      console.log('[useGiftStats] receivedGifts', receivedGifts);
      const totalSent = sentGifts?.length || 0;
      const totalReceived = receivedGifts?.length || 0;
      const totalEarningsNet = receivedGifts?.reduce((sum, gift) => sum + (gift.net_amount || 0), 0) || 0;
      const totalGrossReceived = receivedGifts?.reduce((sum, gift) => sum + (gift.amount || 0), 0) || 0;
      const avgGiftNet = totalReceived ? totalEarningsNet / totalReceived : 0;
      const totalCommissionPaid = sentGifts?.reduce((sum, gift) => sum + (gift.commission_amount || 0), 0) || 0;
      const totalGrossSent = sentGifts?.reduce((sum, gift) => sum + (gift.amount || 0), 0) || 0;

      return {
        totalSent,
        totalReceived,
        totalEarnings: totalEarningsNet,
        totalGrossReceived,
        avgGiftNet,
        totalCommissionPaid,
        totalGrossSent,
      };
    },
  });
};
